"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonTypes_en_us = void 0;
function commonTypes_en_us() {
    return {
        "types.primitives.boolean": "true/false",
        "types.primitives.string": "Characters",
        "types.primitives.number": "Number",
        "types.customtype.singular": "projectspecific type",
        "types.customtype.plural": "projectspecific types",
        "types.customers.singular": "Customer",
        "types.customers.plural": "Customers",
        "types.applications.singular": "Application",
        "types.applications.plural": "Applications",
        "types.auditlog_records.singular": "Audit Log",
        "types.auditlog_records.plural": "Audit Logs",
        "types.subscriptions_booked.singular": "Booked Subscription",
        "types.subscriptions_booked.plural": "Booked Subscriptions",
        "types.calendars.singular": "Calendar",
        "types.calendars.plural": "Calendars",
        "types.calendarentries.singular": "Appointment",
        "types.calendarentries.plural": "Appointments",
        "types.cmspages.singular": "CMS page",
        "types.cmspages.plural": "CMS pages",
        "types.companies.singular": "Company",
        "types.companies.plural": "Companies",
        "types.configurations.singular": "Configuration",
        "types.configurations.plural": "Configurations",
        "types.contact_customfields.singular": "Custom Contact Field",
        "types.contact_customfields.plural": "Custom Contact Fields",
        "types.contacts.singular": "Contact",
        "types.contacts.plural": "Contacts",
        "types.counters.singular": "Counter",
        "types.counters.plural": "Counters",
        "types.countries.singular": "Country",
        "types.countries.plural": "Countries",
        "types.cronjobs.singular": "Cronjob",
        "types.cronjobs.plural": "Cronjobs",
        "types.custombackoffices.singular": "Projectspecific Backoffice",
        "types.custombackoffices.plural": "Projectspecific Backoffices",
        "types.dashboards.singular": "Dashboard",
        "types.dashboards.plural": "Dashboards",
        "types.datatypes.singular": "Datatype",
        "types.datatypes.plural": "Datatypes",
        "types.data.singular": "Data",
        "types.data.plural": "Data",
        "types.device_registrations.singular": "Device Registration",
        "types.device_registrations.plural": "Device Registrations",
        "types.devices.singular": "Device",
        "types.devices.plural": "Devices",
        "types.emaillayouts.singular": "Email Layout",
        "types.emaillayouts.plural": "Email Layouts",
        "types.emailtemplates.singular": "Email Template",
        "types.emailtemplates.plural": "Email Templates",
        "types.emails.singular": "Email",
        "types.emails.plural": "Emails",
        "types.files.singular": "File",
        "types.files.plural": "Files",
        "types.forms.singular": "Form",
        "types.forms.plural": "Forms",
        "types.invitations.singular": "Invitation",
        "types.invitations.plural": "Invitations",
        "types.languages.singular": "Language",
        "types.languages.plural": "Languages",
        "types.locales.singular": "Locale",
        "types.locales.plural": "Locales",
        "types.mailing_channels.singular": "Mailing Channel",
        "types.mailing_channels.plural": "Mailing Channels",
        "types.mailing_deliverable.singular": "Mailing Deliverable",
        "types.mailing_deliverable.plural": "Mailing Deliverables",
        "types.mailing_lists.singular": "Mailing List",
        "types.mailing_lists.plural": "Mailing Lists",
        "types.mailing_sent.singular": "Sent Mailing",
        "types.mailing_sent.plural": "Sent Mailings",
        "types.messages.singular": "Message",
        "types.messages.plural": "Messages",
        "types.notes.singular": "Note",
        "types.notes.plural": "Notes",
        "types.notifications.singular": "Notification",
        "types.notifications.plural": "Notifications",
        "types.optins.singular": "Opt-In",
        "types.optins.plural": "Opt-Ins",
        "types.orders.singular": "Order",
        "types.orders.plural": "Orders",
        "types.permissions.singular": "Permission",
        "types.permissions.plural": "Permissions",
        "types.pricezones.singular": "Price Zone",
        "types.pricezones.plural": "Price Zones",
        "types.products.singular": "Product",
        "types.products.plural": "Products",
        "types.datatemplates.singular": "Data Template",
        "types.datatemplates.plural": "Data Templates",
        "types.projects.singular": "Project",
        "types.projects.plural": "Projects",
        "types.resellers.singular": "Reseller",
        "types.resellers.plural": "Resellers",
        "types.roles.singular": "Role",
        "types.roles.plural": "Roles",
        "types.servicetokens.singular": "Servicetoken",
        "types.servicetokens.plural": "Servicetokens",
        "types.shoppingcarts.singular": "Shopping Cart",
        "types.shoppingcarts.plural": "Shopping Carts",
        "types.subscriptions.singular": "Subscription",
        "types.subscriptions.plural": "Subscriptions",
        "types.suppliers.singular": "Supplier",
        "types.suppliers.plural": "Suppliers",
        "types.tasks.singular": "Task",
        "types.tasks.plural": "Tasks",
        "types.translations.singular": "Translation",
        "types.translations.plural": "Translations",
        "types.todos.singular": "Todo",
        "types.todos.plural": "Todos",
        "types.todotemplates.singular": "Todo Template",
        "types.todotemplates.plural": "Todo Templates",
        "types.users.singular": "Backoffice User",
        "types.users.plural": "Backoffice Users",
        "types.visitors.singular": "Visitor",
        "types.visitors.plural": "Visitors",
        "types.visitorevents.singular": "Visitor Event",
        "types.visitorevents.plural": "Visitor Events",
        "types.printerconfigurations.singular": "Printer Configuration",
        "types.printerconfigurations.plural": "Printer Configurations",
        "types.apps.singular": "App",
        "types.apps.plural": "Apps",
        "types.workflows_executions.singular": "Workflow Execution",
        "types.workflows_executions.plural": "Workflow Executions",
        "types.workflows.singular": "Workflow",
        "types.workflows.plural": "Workflows",
        "types.worklogs.singular": "Worklog",
        "types.worklogs.plural": "Worklogs",
        "types.pdftemplates.singular": "PDF Template",
        "types.pdftemplates.plural": "PDF Templates"
    };
}
exports.commonTypes_en_us = commonTypes_en_us;
